import { createContext, useContext } from 'react'

/**
 * Holds a DOM element that overlay popups (combobox, etc.) should portal into,
 * instead of document.body. Used to keep Base UI popups inside a Radix Dialog's
 * focus scope — otherwise the dialog's focus trap steals focus and closes the
 * popup before a value can be selected.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null)

export function usePortalContainer(): HTMLElement | null {
  return useContext(PortalContainerContext)
}
